/**
 * @cockpit/firebase — Shared Firebase initialization.
 *
 * Exports only the Firebase App instance and config.
 * Auth is NOT initialized here — each app must initialize Auth itself:
 *   - Web: getAuth(app)          → uses IndexedDB persistence automatically
 *   - RN:  initializeAuth(app, { persistence: getReactNativePersistence(AsyncStorage) })
 *
 * db, storage, functions also require platform-specific initialization.
 * Each app initializes everything in its own shared/api layer.
 */

import { initializeApp } from 'firebase/app';
import { firebaseConfig } from './config';

export const app = initializeApp(firebaseConfig);

export { firebaseConfig } from './config';
